import {useQueries} from "@tanstack/react-query";
import VehicleControlMileageService from "../../../../../services/reports/vehicle-control-mileage-service.js";

const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['vehicles'],
                queryFn: () => VehicleControlMileageService.allControlMileage(),
                initialData: []
            }
        ]
    });

    return {
        vehiclesOptions: queries[0].data
    };
};

export default UseFetchOptions;